{
  "nl": {
    "todo": {
      "actions": {
        "add": "Taak Toevoegen",
        "cancel": "Annuleer",
        "delete_todo": "Verwijder taak",
        "edit": "Taak wijzigen",
        "save": "Opslaan"
      },
      "attributes": {
        "active": "Actief",
        "assignee": "Verantwoordelijke",
        "completed": "Voltooid",
        "description": "Omschrijving",
        "due_date": "Deadline",
        "title": "Titel"
      },
      "labels": {
        "active": "actief",
        "allDone": "Alle taken zijn voltooid!",
        "allTodos": "Alle Taken",
        "completed": "voltooid",
        "filterTodos": "Filter taken",
        "filters": "Filters",
        "myTodos": "Mijn Taken",
        "myTodosCount": "Mijn taken ({count})",
        "noActiveTodos": "Geen actieve taken",
        "noActiveTodosDashboard": "Proficiat, je hebt geen openstaande taken!",
        "noCompletedYet": "Nog geen voltooide taken.",
        "noTodosCustomer": "Super! Je hebt geen openstaande taken.",
        "selectAProjectFirst": "Selecteer eerst een project",
        "showLess": "Toon minder",
        "showOthers": "Toon meer | Toon meer ({count})"
      },
      "toasts": {
        "create": "Taak aangemaakt",
        "delete": "Taak verwijderd",
        "update": "Taak gewijzigd"
      },
      "validation": {
        "needtitle": "Titel is verplicht"
      }
    }
  }
}
